module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba-funabashi-point2-2@2x-d2ed7442c4f694924657397da0e84cac.webp";